import React from 'react';
import PropTypes from 'prop-types';
import withAccountFormStepStyles from 'Components/UI/Accounts/AccountApplication/Step/withAccountFormStepStyles';
import MetaField from 'Components/UI/Meta/MetaForm/Components/MetaControlField';
import Typography from 'Components/UI/Typography';
import SocialSecurityField from 'Components/UI/Accounts/AccountApplication/Step/Fields/SocialSecurityField';

function DecedentInformation({ classes }) {
  return (
    <div className={classes.root}>
      <div className={classes.row}>
        <Typography
          className={classes.header}
          variant="h3"
          color="primary"
          component={'h2'}
        >
          {'Decedent Information'}
        </Typography>
      </div>
      <div className={classes.row}>
        <MetaField attr="decedentName" />
      </div>
      <div className={classes.row}>
        <MetaField attr="decedentDateOfDeath" />
        <MetaField attr="decedentDateOfBirth" />
      </div>
      <div className={classes.row}>
        <SocialSecurityField attr="decedentSocialSecurityNumber" />
      </div>
    </div>
  );
}
DecedentInformation.propTypes = {
  classes: PropTypes.object.isRequired,
};
export default withAccountFormStepStyles(DecedentInformation);
